module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "brand", "brandConfig", "session", "sessionData", "$cookies", "$http",
        function (Service, $q, brand, brandConfig, session, sessionData, $cookies, $httpProvider) {

        new Service({
            name: 'clientSearch',
            group:"eprsvc",
            url:"/eprsvc/x-services/secure/client/v1/search",
            headers: {},
            submitSearch: function(empNumber, empName, empNameSearchType) {
                this.headers['APPID'] = "EPRWEB";
                // this.headers['FromDP']= "LIDUWT1"; <--- THIS CAN'T BE HERE
                this.headers['clientHost'] = "hmhs.com";
                var searchTypePair = "?clientNameSearchType="+empNameSearchType;
                var empNumberPair= (empNumber.length>0) ? "&clientNumber="+empNumber : '';
                var empNamePair = (empName.length>0) ? "&clientName="+empName : '';

                this.url += searchTypePair + empNumberPair + empNamePair;
                return this.get();
            }
        });
    }]);
};
